import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { Capability } from 'src/app/modules/common/_types/capability';

import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation, NotFilter, OrFilter } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { RateLine } from 'src/app/modules/rates/_types/rate-line';
import { Job } from 'src/app/modules/cases/_types/job';
import { CaseService } from 'src/app/modules/cases/_types/case-service';
import { CasesServicesService } from 'src/app/modules/cases/_services/cases-services.service';
import { JobsService } from 'src/app/modules/cases/_services/jobs.service';
import { RatesService } from 'src/app/modules/rates/_services/rates.service';
import { Tax } from 'src/app/modules/taxes/_types/tax';
import { TaxesService } from 'src/app/modules/taxes/_services/taxes.service';
import { Rate } from 'src/app/modules/rates/_types/rate';
import { CapabilitiesService } from 'src/app/modules/common/_services/capabilities.service';
import { CasesService } from 'src/app/modules/cases/_services/cases.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { WorkerCapabilitiesService } from 'src/app/modules/workers/_services/workers-capabilities.service';
import { WorkerCapability } from 'src/app/modules/workers/_types/worker-capability';
import { Validators } from '@angular/forms';
import { ProviderCapabilitiesService } from 'src/app/modules/providers/_services/providers-capabilities.service';
import { NumberUtilsService } from 'src/app/core/services/number-utils.service';
import { worker } from 'monaco-editor';
import { WorkersService } from 'src/app/modules/workers/_services/workers.service';
import { Case } from 'src/app/modules/cases/_types/case';
import { AffectedsService } from 'src/app/modules/cases/_services/affecteds.service';

@Component({
    selector: 'app-case-service-job',
    templateUrl: './case-service-job.component.html',
    styleUrls: ['./case-service-job.component.scss'],
    standalone: false
})
export class CaseServiceJobComponent {
  public jobFormGroup!: RxFormGroup;

  public job: Job = new Job();
  public jobs: Job[] = [];

  public selectedRateId: string | null = null;
  public rates: Rate[] = [];
  public allRates: Rate[] = [];
  public capabilities: Capability[] = [];
  public allCapabilities: Capability[] = [];

  public workerCapabilities: WorkerCapability[] = [];
  public providerCapabilities: any[] = [];

  public caseServices: CaseService[] = [];
  public companyId!: string;
  public workerId!: string;
  public providerId!: string;
  public insuranceCompanyId!: string | null;
  public contractId!: string | null;
  public rateLines: RateLine[] = [];
  public selectedCapability: string | undefined;
  public rateLineSelected: any = {
    freePrice: true
  };
  public hasSubmitInvoice: boolean = false;
  public allRateLines: any;
  public jobType!: string;
  public isGuard!: boolean;

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public allowDeleteAll: boolean = false;
  public taxes: Tax[] = [];
  public loadingTaxes: boolean = false;
  public targets: any[] = [
    { id: "Company", name: 'Companía' },
    { id: "Client", name: 'Asegurado' },
    { id: "ThirdParty", name: 'Implicado' }
  ];

  public case!: Case;
  public jobGuardCompanyIncrementAmount: number = 0;
  public jobCompanyDiscountAmount: number = 0;
  public showCasesServices: boolean = false;
  public firstTime: boolean = true;
  public workerEconomicNotes?: string; 
  public affecteds : any[] = [];
  constructor(
    private jobsService: JobsService,
    private casesServicesService: CasesServicesService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private ratesService: RatesService,
    private capabilitiesService: CapabilitiesService,
    private workerCapabilitiesService: WorkerCapabilitiesService,
    private providerCapabilitiesService: ProviderCapabilitiesService,
    private taxesService: TaxesService,
    private casesService: CasesService,
    private loginService: LoginService,
    private numberUtilsService:NumberUtilsService,
    private workerService: WorkersService,
    private affectedsService: AffectedsService
  ) {
    this.jobFormGroup = this.formBuilder.formGroup(Job) as RxFormGroup;
      this.jobFormGroup.get("quantity")?.addValidators(Validators.required); //fuerzo a obligatorio porque no está como obligatorio en el modelo. Sino que pongan 0.
      this.jobFormGroup.get("unitPrice")?.addValidators(Validators.required);
  }

  async ngOnInit() {
    await this.loadTaxes();
    await this.loadCapabilities();
    await this.loadRates();
    let jobId = this.config.data.id;
    this.companyId = this.config.data.companyId;
    this.workerId = this.config.data.workerId;
    this.providerId = this.config.data.providerId;
    this.jobType = this.config.data.type;
    this.insuranceCompanyId = this.config.data.insuranceCompanyId;
    this.contractId = this.config.data.contractId;
    this.isGuard = this.config.data.isGuard;

    if (jobId) {
      await this.loadJob(jobId);
    } else {
      this.job.caseId = this.config.data.caseId;
      this.job.caseServiceId = this.config.data.caseServiceId;
      this.selectedCapability = this.config.data.capabilityId;
      this.job.taxPercent = this.taxes.filter(m => m.default)[0].percent;
      this.job.isBillable = true;
      this.job.isReview = true;
      this.job.target = this.targets[0].id;
      this.job.providerId = this.providerId;

      await this.loadCase();

      this.jobFormGroup.patchValue(this.job);
      await this.loadRateLines();

    }

    this.loadWorker();
    this.allowWrite = this.loginService.hasPermission("CASES.WRITE");
    this.allowDelete = this.loginService.hasPermission("CASES.DELETE");  
    this.allowDeleteAll = this.loginService.hasPermission("CASES.DELETE_INVOICED_JOBS");

    if(this.providerId == null || this.providerId == "undefined"){
      this.jobFormGroup.get("rateLineId")?.addValidators(Validators.required);
    }
    await this.loadCaseServices();

  }

  async loadJob(jobId: string) {
    this.job = await firstValueFrom(this.jobsService.get(jobId, { include: ['rateLine'] }));

    //Si tiene transactionId bloqueamos todo
    if (this.job.transactionId != null || this.job.isBillable) {
      await this.disableControls();
    }
    
    //si viene de un workerline, no puede modificarse, ni ponerse el facturable
    if(this.job.workerBillableItemLineId){
      this.jobFormGroup.get('isBillable')?.disable();
      await this.disableControls();
    }
    await this.loadCase();
    await this.loadRateLines();
    if (this.job.rateLine) {
      this.selectedCapability = this.job.rateLine.capabilityId;
      this.selectedRateId = this.job.rateLine.rateId;
      this.selectedCapability = this.job.rateLine.capabilityId;
      this.filterRatesLines();
    }
    this.jobFormGroup.patchValue(this.job);
    if(!this.job.isReview) this.jobFormGroup.get('isBillable')?.disable(); //si no se ha revisado, no se puede marcar como facturable
  }

  async disableControls() {
    this.jobFormGroup.get('date')?.disable();
    this.jobFormGroup.get('rateLineId')?.disable();
    this.jobFormGroup.get('description')?.disable();
    this.jobFormGroup.get('quantity')?.disable();
    this.jobFormGroup.get('unitPrice')?.disable();
    this.jobFormGroup.get('isReview')?.disable();
    this.jobFormGroup.get('taxPercent')?.disable();
    this.jobFormGroup.get('jobCompanyDiscountPercent')?.disable();
    this.jobFormGroup.get('jobGuardCompanyIncrementPercent')?.disable();
    if (this.job.transactionId != null) {
      this.jobFormGroup.get('isBillable')?.disable();
    }

  }


  async enableControls() {
    
    console.log(this.rateLineSelected.freePrice);

    this.jobFormGroup.get('date')?.enable();
    this.jobFormGroup.get('rateLineId')?.enable();
    this.jobFormGroup.get('description')?.enable();
    this.jobFormGroup.get('quantity')?.enable();
    if(this.rateLineSelected.freePrice) this.jobFormGroup.get('unitPrice')?.enable();
    this.jobFormGroup.get('isReview')?.enable();
    this.jobFormGroup.get('taxPercent')?.enable();
    this.jobFormGroup.get('jobCompanyDiscountPercent')?.enable();
    this.jobFormGroup.get('jobGuardCompanyIncrementPercent')?.enable();
  }

  async loadCase() {
    //Lo pasamos a un get porque sino por permisos puede no funcionar a gente
     let params: IParamsCollection = {
      include: ['contract']
    }
    this.case = await firstValueFrom(this.casesService.get(this.job.caseId, params));

    if (this.jobType == "COMPANY") {
      if(!this.job.id){ //solo al crearlo, para que no elimine el dato ya introducido.
        this.job.jobCompanyDiscountPercent = this.case.contract?.jobCompanyDiscountPercent;
        if (this.isGuard) this.job.jobGuardCompanyIncrementPercent = this.case.contract?.jobGuardCompanyIncrementPercent;
      }
    }
  }

  async loadCaseServices() {
    let params: IParamsCollection = {
      include: ['worker'],
    }
    let filters: any = {
      caseId: new Filter(FilterOperation.equals, "caseId"),
    };

    filters.caseId.value = this.job.caseId;
    params.filter = FilterBuilder.fromObject(filters).build();

    let response: any = await firstValueFrom(this.casesServicesService.all(params));
    this.caseServices = response.data;
   
  }

  async loadCapabilities() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: {
        size: 1000
      }
    }
    let response = await firstValueFrom(this.capabilitiesService.all(params));
    this.allCapabilities = response.data;
  }


  async loadWorkerCapabilities() {
    let filter : any = {
      workerId: new Filter(FilterOperation.equals, "workerId", '', this.workerId)
    };
    let params: IParamsCollection = {
      page: {
        size: 1000
      },
      filter: FilterBuilder.fromObject(filter).build()
    }
    let response = await firstValueFrom(this.workerCapabilitiesService.all(params));
    this.workerCapabilities = response.data;
  }

  
  async loadProviderCapabilities() {
    let filter : any = {
      providerId: new Filter(FilterOperation.equals, "providerId", '', this.providerId)
    };
    let params: IParamsCollection = {
      page: {
        size: 1000
      },
      filter: FilterBuilder.fromObject(filter).build()
    }
    let response = await firstValueFrom(this.providerCapabilitiesService.all(params));
    this.providerCapabilities = response.data;
  }

  async loadRates() {
    let params: IParamsCollection = {
      sort: ['name'],
      page: {
        size: 1000
      }
    }
    let response = await firstValueFrom(this.ratesService.all(params));
    this.allRates = response.data;
  }

  async loadRateLines() {

    //si es compañia, las de la compñía si no es, es el caso de trabajador o proveedor.
    let sendJobType = "";
    let sendCompanyIdProviderIdWorkerId = "";

    if(this.jobType == "COMPANY"){
        sendJobType = "COMPANY";
        sendCompanyIdProviderIdWorkerId = this.companyId;
    }else{
        sendJobType = this.providerId == null ? this.jobType : "PROVIDER";
        sendCompanyIdProviderIdWorkerId = this.providerId == null ? this.workerId : this.providerId;
    }

    //calculamos la fecha de referencia para el baremo, si es compañia se debea usar la fecha de expediente, si no, la fecha del trabajo.
    let refDate = this.job.date;
    if(this.jobType == "COMPANY"){
      refDate = this.case?.caseDate;
    }
    this.allRateLines = await firstValueFrom(this.ratesService.rateLinesCompany(sendJobType, sendCompanyIdProviderIdWorkerId, refDate, this.insuranceCompanyId, this.contractId, this.isGuard));
    let capabilityIds = [...new Set(this.allRateLines.map((m: any) => m.capabilityId))];

    //si es de tipo WORKER, filtramos por las capacidades del trabajador
    if (this.jobType == "WORKER") {
      await this.loadWorkerCapabilities();
      capabilityIds = this.workerCapabilities.map((m: WorkerCapability) => m.capabilityId);
    }

    //Si es un proveedor (y no es una compañia), filtramos por las capacidades del proveedor.(TODO: Implementar esta parte en la app porque no esta.)
    if(this.providerId != null && this.jobType != "COMPANY"){
      await this.loadProviderCapabilities();
      capabilityIds = this.providerCapabilities.map((m: any) => m.capabilityId);
    }

    this.capabilities = this.allCapabilities.filter((m: any) => capabilityIds.includes(m.id));

    //extraemos los rateid unicos
    let rateIds = [...new Set(this.allRateLines.map((m: any) => m.rateId))];
    this.rates = this.allRates.filter((m: any) => rateIds.includes(m.id));

    this.filterRatesLines();
  }

  async loadTaxes() {
    this.loadingTaxes = true;
    let params: IParamsCollection = {
    }

    let response = await firstValueFrom(this.taxesService.all(params));
    this.taxes = response.data;

    this.loadingTaxes = false;
  }

  filterRatesLines() {
    let ratesLines = this.allRateLines;
    if (this.selectedRateId != null) ratesLines = ratesLines.filter((m: any) => m.rateId == this.selectedRateId);
    if (this.selectedCapability != null) ratesLines = ratesLines.filter((m: any) => m.capabilityId == this.selectedCapability);

    if (this.job.rateLineId != null) {
      this.rateLineSelected = ratesLines.find((m: any) => m.id == this.job.rateLineId);
      if (typeof this.rateLineSelected != "undefined") {
        if (!this.rateLineSelected.freePrice) {
          this.jobFormGroup.get('unitPrice')?.disable();
        }
        if (this.rateLineSelected.fixedAmount != null) {
          this.jobFormGroup.get('quantity')?.disable();
        }
      }
    }

    this.rateLines = ratesLines;
  }

  selectCapability(event: any) {
    this.selectedCapability = event.value;
    this.filterRatesLines();
  }

  selectRate(event: any) {
    this.selectedRateId = event.value;
    this.filterRatesLines();
  }

  selectRateLine(e: any) {
    this.rateLineSelected = e;
    this.job.unitPrice = this.rateLines.find((rl: any) => rl.id == e.value)?.price || 0;
    this.jobFormGroup.patchValue({ unitPrice: this.job.unitPrice });
  }

  // Función para generar el label concatenado
  getOptionLabel(option: any) {

    return option.code + " - " + option.description;
  }


  cancel() {
    this.dynamicDialogRef.close();
  }

  getRate(id: string): Rate | undefined {
    return this.allRates.find((m: Rate) => m.id == id);
  }

  async preSave() {

    let valid = this.formValidationService.validateForm(this.jobFormGroup);
    if (valid) {

      //comprobamos si es de operario y facturable, y no tiene ya factura, no podemos poner fecha anterior al 26 del mes anterior
      if(!this.job.isForCompany && this.jobFormGroup.get('isBillable')?.enabled && this.jobFormGroup.get('isBillable')?.value && this.job.transactionId == null){
        let today = new Date();
        let limitDate = new Date(today.getFullYear(), today.getMonth() -1, 26);
        if(this.jobFormGroup.get('date')?.value < limitDate){
          this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "No se puede marcar como facturable un trabajo con fecha anterior al 26 del mes anterior." });
          return;
        }
      }

      this.job = Object.assign(this.job, this.jobFormGroup.getRawValue());

      //Buscamos el resto de líneas para verficar códigos incompatibles y 
      // servicios únicos.
      if (this.rateLineSelected != null && (this.rateLineSelected.incompatibleCodes != "" && this.rateLineSelected.incompatibleCodes != null || this.rateLineSelected.uniqueService)) {
        let params: IParamsCollection = {
          include: ['rateLine']
        }

        let filters: any = {
          caseServiceId: new Filter(FilterOperation.equals, "caseServiceId"),
        };

        if (this.job.id != "") {
          filters.id = new NotFilter(FilterOperation.equals, 'id', '', this.job.id, true);
        }

        filters.caseServiceId.value = this.job.caseServiceId;
        params.filter = FilterBuilder.fromObject(filters).build();

        let otherJobs: any = await firstValueFrom(this.jobsService.all(params));

        if (this.rateLineSelected.incompatibleCodes != "" && this.rateLineSelected.incompatibleCodes != null) {
          let incompatibleCodesFound: string = "";
          let incompatibleCodes = this.rateLineSelected.incompatibleCodes.split(',');

          const promesas = incompatibleCodes.map((incompatibleCode: string) => {
            this.checkCode(otherJobs, incompatibleCode).then(value => {
              if (value.length > 0) {
                incompatibleCodesFound += value[0].rateLine.code + ";";
              }
            });
          });

          await Promise.all(promesas);  // Espera que todas las promesas se resuelvan

          if (incompatibleCodesFound != "") {
            this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "El baremo indicado no es compatible con los siguientes códigos: " + incompatibleCodesFound });
          } else {
            //Comprobamos si es servicio único
            if (this.rateLineSelected.uniqueService) {
              if (this.checkUniqueService(otherJobs).length > 0) {
                this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Ya existe un baremo que es único en el servicio" });
              } else {
                this.save();
              }
            } else {
              this.save();
            }
          }
        } else {
          if (this.checkUniqueService(otherJobs).length > 0) {
            this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Ya existe un baremo que es único en el servicio" });
          } else {
            this.save();
          }
        }
      } else {
        this.save();
      }

    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }

  }

  checkUniqueService(otherJobs: any) {
    return otherJobs.data.filter((m: any) => m.rateLine.uniqueService);
  }

  async checkCode(otherJobs: any, code: string): Promise<any> {
    return new Promise(resolve => {
      let result = otherJobs.data.filter((m: any) => m.rateLineId == code);
      resolve(result);
    });
  }

  async save() {
    // asignar el precio unitario de la línea de tarifa
    if (this.job.rateLineId) {
      this.job.rateLineUnitPrice = this.rateLines.find((rl: any) => rl.id == this.job.rateLineId)?.price || 0;
    }

    //asignar operario desde el servicio
    this.job.workerId = this.caseServices.find((cs: any) => cs.id == this.job.caseServiceId)?.workerId || null;

    if (this.jobType == "COMPANY") this.job.isForCompany = true;

    let job: any = await firstValueFrom(this.jobsService.save(this.job));
    this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Trabajo guardado correctamente." });
    
    this.dynamicDialogRef.close(this.job.id ? null : job.id);
        

  }

  delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el trabajo?",
      header: "Eliminar trabajo",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.jobsService.delete(this.job.id).subscribe({
          next: () => {
            this.messageService.add({ closable: true, severity: 'success', detail: "Trabajo eliminado correctamente." });
            this.dynamicDialogRef.close();
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  // Asignar el precio unitario de la línea de tarifa al cambiar la línea de tarifa
  onRateLineChange(e: any) {
    if(e.value == null){
      this.selectedRateId = null;
      this.filterRatesLines();
    }
    this.rateLineSelected = this.allRateLines.find((rateLine: any) => rateLine.id == e.value);
    this.jobFormGroup.controls['unitPrice'].setValue(this.rateLineSelected?.price || 0);
    if (this.rateLineSelected) {
      if (!this.rateLineSelected.freePrice) {
        this.jobFormGroup.get('unitPrice')?.disable();
      } else {
        this.jobFormGroup.get('unitPrice')?.enable();
      }
      if (this.rateLineSelected.fixedAmount != null) {
        this.jobFormGroup.controls['quantity'].setValue(this.rateLineSelected.fixedAmount);
        this.jobFormGroup.get('quantity')?.disable();
      } else {
        this.jobFormGroup.controls['quantity'].setValue(1);
        this.jobFormGroup.get('quantity')?.enable();
      }
    }

    this.calculatePrices();
  }

  async loadAffecteded() {    
    //cargamos los afectados
    let filter : any = {
      caseId: new Filter(FilterOperation.equals, "caseId", '', this.job.caseId)
    };
    let params:IParamsCollection = {
      page: { size: 50 },
      sort: ['name'],
      filter: FilterBuilder.fromObject(filter).build()
    };
    let response = await firstValueFrom(this.affectedsService.all(params));
    this.affecteds = response.data;
  }

  onTargetChange(e: any) {
    if (this.job.id == "") {
      if (e.value == "Client") {
        this.jobFormGroup.controls['taxPercent'].setValue(this.taxes.filter(m => m.code == "REDUCED")[0].percent);
        this.calculatePrices();
        this.jobFormGroup.get('taxPercent')?.enable();
      }
      if (e.value == "Company") {
        this.jobFormGroup.controls['taxPercent'].setValue(this.taxes.filter(m => m.default)[0].percent);
        this.calculatePrices();
        this.jobFormGroup.get('taxPercent')?.disable();
      }
      if (e.value == "ThirdParty") {
        this.jobFormGroup.controls['taxPercent'].setValue(this.taxes.filter(m => m.default)[0].percent);
        this.calculatePrices();
        this.jobFormGroup.get('taxPercent')?.enable();
       // this.loadAffecteded();
      }
    }
  }

  // Controlar si el operario del servicio seleccionado tiene que emitir factura
  onCaseServiceChange() {
    let caseServiceId = this.jobFormGroup.controls['caseServiceId'].value;
    this.hasSubmitInvoice = this.caseServices.find((cs: any) => cs.id == caseServiceId)?.worker?.hasSubmitInvoice || false;
  }

  calculatePrices() {
    const quantity = this.jobFormGroup.controls["quantity"].value || 0;
    const unitPrice = this.jobFormGroup.controls["unitPrice"].value || 0;
    const discountPercent = this.jobFormGroup.controls["jobCompanyDiscountPercent"].value || 0;
    const incrementPercent = this.isGuard ? (this.jobFormGroup.controls["jobGuardCompanyIncrementPercent"].value || 0) : 0;
    const taxPercent = this.jobFormGroup.controls["taxPercent"].value || 0;

    // 1. Subtotal sin modificaciones
    let subtotal = this.numberUtilsService.Round(quantity * unitPrice);

    // 2. Aplicar descuento de compañía, redondeado a 2 decimales
    let discountAmount = subtotal * (discountPercent / 100);
    discountAmount = this.numberUtilsService.Round(discountAmount);
    this.jobCompanyDiscountAmount = discountAmount;
    subtotal -= discountAmount;

    // 3. Aplicar incremento por guardia (solo si aplica)
    let incrementAmount = subtotal * (incrementPercent / 100);
    incrementAmount = this.numberUtilsService.Round(incrementAmount);
    this.jobGuardCompanyIncrementAmount = incrementAmount;
    subtotal += incrementAmount;

    // 4. Calcular impuestos
    let taxAmount = subtotal * (taxPercent / 100);
    taxAmount = this.numberUtilsService.Round(taxAmount);
    this.jobFormGroup.controls["taxAmount"].setValue(taxAmount);

    // 5. Calcular total final
    const finalPrice = subtotal + taxAmount;
    this.jobFormGroup.controls["total"].setValue(finalPrice);
  }

  toggleFormState() {
    if (this.job.id != "" && this.jobFormGroup.controls['isBillable'].value) {
      //si el trabajo es marcado como facturable. 
      if(!this.job.isForCompany && this.jobFormGroup.get('isBillable')?.enabled && this.job.transactionId == null){
        //ponemos la fecha a hoy si es menor que hoy. Así entra en esta nueva factura.
        if(this.jobFormGroup.get('date')?.value < new Date()){
          this.jobFormGroup.controls['date'].setValue(new Date());
        }
      }

      this.disableControls();
    } else {
      this.enableControls();
    }
  }

  getVisibleFieldsCount(): number {
    let count = 3; // quantity, unitPrice, tax

    if (this.jobType === 'COMPANY') {
      count++; // discount
      if (this.isGuard) count++; // guard increment
    }

    count++; // total is always shown

    return count;
  }

  getFieldColClass(): string {
    const count = this.getVisibleFieldsCount();
    const colSize = Math.floor(12 / count);
    return `col-${colSize}`;
  }

  toggleNoProcede(event: any){    
    this.showCasesServices = event.checked;
    if(!this.showCasesServices){
      this.jobFormGroup.controls["relatedJobId"].setValue(null);
    }
    if(this.firstTime) this.loadJobs();
    this.firstTime = false;
  }

  async loadJobs() {    
    let params: IParamsCollection = {  
      include: [ 'caseService', 'worker'],
      page: { number: 1, size: 200 } //hay servicios que tienen mas de 100 trbajo. ejemplo 3524010456
    }
    let filters: any = {      
      caseId: new Filter(FilterOperation.equals, "caseId",'',this.job.caseId),   
      //caseServiceDeleted: new Filter(FilterOperation.equals, "caseService.deleted", '', false)         
      caseService: new OrFilter([
        new Filter(FilterOperation.equals, "caseService.deleted", '', false),
        new Filter(FilterOperation.equals, "caseServiceId", '', null, true)
      ]),
      isForCompany: new Filter(FilterOperation.equals, "isForCompany", "", true)
    };
    params.filter = FilterBuilder.fromObject(filters).build();      
    let response = await firstValueFrom(this.jobsService.all(params));
    this.jobs = response.data;
     // añadir atributo que sea 'worker.name' - 'date'
    this.jobs.forEach((job: any) => {
      job.label = `${job.worker?.name} - ${job.date.toLocaleString()}`;
    });
  }

  async loadWorker(){
    if(this.workerId != null){
      let worker = await firstValueFrom(this.workerService.get(this.workerId));
      this.workerEconomicNotes = worker.economicNotes;
    }
  }

}
